// ======================= Imports =======================
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./AppMenu.css";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";

// ======================= Main Component =======================
export const AppMenu = ({ setMobileMenuActive, model }) => {
  // ======================= State Management =======================
  const location = useLocation(); // current route location
  const [overlayContent, setOverlayContent] = useState("");
  const tooltipMainModule = useRef();
  const [active, setActive] = useState(false);
  const [expandSidebar, setExpandSidebar] = useState(false);
  const [currentLocation, setCurrentLocation] = useState();
  const [currentActive, setCurrentActive] = useState();
  const [showDialog, setShowDialog] = useState(false); // leave-page confirmation dialog
  const [nextPath, setNextPath] = useState();
  let navigate = useNavigate();

  // ======================= Sync Active Module With Route =======================
  // Detect active module & submodule based on current URL
  useEffect(() => {
    if (model && model.length > 0 && model[0]?.items) {
      model[0].items.forEach((element, index) => {
        element.subModules.forEach((element2) => {
          if (element2?.route === location?.pathname) {
            setCurrentActive(index);
            setCurrentLocation(element2?.route);
          }
        });
      });
    }

    // Reset state on home route
    if (location.pathname === "/") {
      setCurrentActive();
      setCurrentLocation();
    }
  }, [location, model]);

  // ======================= Sidebar Expand / Collapse Handling =======================
  // Handles outside click & responsive sidebar behavior
  useEffect(() => {
    document.addEventListener(
      "click",
      (e) => {
        e.stopPropagation();
        setExpandSidebar(false);
      },
      false,
    );

    window.addEventListener(
      "resize",
      () => {
        // Responsive sidebar logic intentionally kept commented
      },
      false,
    );
  }, [expandSidebar]);

  // ======================= Render =======================
  return (
    <div
      onClick={(e) => {
        e.stopPropagation(); // prevent sidebar close on inner clicks
      }}
      className={`layout-menu-container sidebar-wrapper ${
        expandSidebar && "expanded-container"
      }`}
    >
      {/* ======================= Sidebar Toggle ======================= */}
      <div
        className="w-full main-menu flex flex-wrap flex-row justify-content-center align-content-start align-items-start"
        style={{ marginTop: "6rem" }}
      >
        <div
          onClick={(e) => {
            e.stopPropagation();
            setExpandSidebar((prev) => !prev);
          }}
          className="drawer-icon"
        >
          <i
            className={`pi ${
              expandSidebar ? "pi-angle-left" : "pi-angle-right"
            }`}
          />
        </div>

        {/* ======================= Main Modules ======================= */}
        {model[0]?.items?.map((element, index) => {
          return (
            <div
              key={index}
              className="cursor-pointer sidebar-container w-full flex flex-wrap flex-row align-items-center justify-content-between"
            >
              {/* ======================= Module Item ======================= */}
              <div
                id={`${element.moduleName}`}
                onClick={() => {
                  // Toggle module expand / collapse
                  if (currentActive !== index) {
                    setCurrentActive(index);
                    setActive(true);
                    setTimeout(() => {
                      const element2 = document.getElementById(
                        element.moduleName,
                      );
                      element2.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                      });
                    }, 100);
                  } else {
                    if (window.innerWidth > 1400 || expandSidebar) {
                      setCurrentActive();
                      setCurrentLocation();
                    }
                  }
                }}
                className={
                  currentActive === index && active
                    ? "notactivemain w-full flex flex-wrap flex-row align-items-center justify-content-between"
                    : currentActive === index
                      ? "activemenu w-full flex flex-wrap flex-row align-items-center justify-content-between"
                      : "main-sidebar-item-label w-full flex flex-wrap flex-row align-items-center justify-content-between"
                }
              >
                <div className="main-sidebar-item-container flex flex-wrap flex-row align-items-center">
                  {/* ======================= Module Icon ======================= */}
                  <div
                    onClick={() => {
                      if (window.innerWidth < 1400) {
                        setExpandSidebar(true);
                      }
                    }}
                    onMouseEnter={(e) => {
                      setOverlayContent(element.moduleName);
                      if (window.innerWidth < 1400) {
                        tooltipMainModule.current.show(e);
                      }
                    }}
                    onMouseLeave={() => tooltipMainModule.current.hide()}
                    style={{ marginTop: "0.55rem" }}
                    dangerouslySetInnerHTML={{ __html: element?.icon }}
                  />

                  <OverlayPanel ref={tooltipMainModule}>
                    <div style={{ maxWidth: "20rem", padding: "0.5rem 1rem" }}>
                      <p className="tooltip-text">{overlayContent}</p>
                    </div>
                  </OverlayPanel>

                  <span>{element.moduleName}</span>
                </div>

                {/* ======================= Dropdown Indicator ======================= */}
                <div className="dropdownico-maincontainer">
                  <i className="dropdown-svg pi pi-fw pi-angle-down menuitem-toggle-icon" />
                </div>
              </div>

              {/* ======================= Submodules ======================= */}
              {currentActive === index && (
                <div className="w-full current-opensubmodules flex-wrap flex-row justify-content-center">
                  {element.subModules?.map((element2, index2) => {
                    return (
                      <React.Fragment key={index2}>
                        {/* Filtered submodules intentionally excluded */}
                        {element2.subModuleName !== "Wifi Calling" &&
                          element2.subModuleName !== "Query Network" &&
                          element2.subModuleName !== "Query Sim" &&
                          element2.subModuleName !== "Imei Validation" &&
                          element2.subModuleName !== "Linked Accounts" &&
                          element2.subModuleName !== "Add Services" &&
                          element2.subModuleName !== "Usage" &&
                          element2.subModuleName !== "Files" &&
                          element2.subModuleName !== "Bulk Update" &&
                          element2.subModuleName !== "Add Unit" &&
                          element2.subModuleName !== "Billing And Invoice" && (
                            <div className="main-dropdown-list w-full flex flex-wrap flex-row align-items-center justify-content-between">
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();

                                  // Close mobile menu on navigation
                                  if (window.innerWidth < 978) {
                                    setMobileMenuActive(false);
                                  }

                                  // Show confirmation dialog for unsaved flows
                                  if (
                                    currentLocation ===
                                      "/prepaid-newenrollment" ||
                                    currentLocation ===
                                      "/postpaid-newenrollment" ||
                                    currentLocation === "/add-service"
                                  ) {
                                    setShowDialog(true);
                                    setNextPath(element2?.route);
                                  } else {
                                    navigate(element2?.route);
                                  }

                                  setCurrentLocation(element2?.route);
                                  setActive(false);
                                }}
                                className="main-box-submodule"
                              >
                                <span
                                  className={
                                    currentLocation === element2.route
                                      ? "selected-span-sidebar"
                                      : "sidebar-dropdown-menu-span"
                                  }
                                >
                                  {element2.subModuleName}
                                </span>
                              </div>
                            </div>
                          )}
                      </React.Fragment>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* ======================= Leave Page Confirmation Dialog ======================= */}
      <Dialog
        header={null}
        visible={showDialog}
        headerClassName="header-dialog"
        style={{ width: "68rem", height: "26.6rem" }}
        onHide={() => setShowDialog(false)}
      >
        <div className="dialogcontent">
          <h1>Are You Sure You Want to Leave?</h1>
          <p>
            You are currently on the New Enrollment page. This enrollment will
            be saved as incomplete.
          </p>

          <div
            style={{ gap: "1rem" }}
            className="flex justify-content-end gap-4"
          >
            <Button
              className="backbtn"
              label="Stay on Page"
              onClick={() => setShowDialog(false)}
            />
            <Button
              className="nextbtn"
              label="Leave Page"
              onClick={() => {
                navigate(nextPath);
                setShowDialog(false);
              }}
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
};
